<template>
  <div id="user-edit-account-details">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h3>Role details</h3>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-1/2">
        <vs-input class="w-full mt-4" label="Name" v-model="data_local.RoleName" v-validate="'required'"
                  name="RoleName" />
        <span class="text-danger text-sm"  v-show="vErrors.has('RoleName')">{{ vErrors.first('RoleName') }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-input class="w-full mt-4" label="Description" v-model="data_local.RoleDescription"
                  v-validate="'required'"
                  name="RoleDescription" />
        <span class="text-danger text-sm"  v-show="vErrors.has('RoleDescription')">{{ vErrors.first('RoleDescription')
          }}</span>
      </div>
    </div>
    <div class="vx-row mt-4">
      <div class="vx-col w-1/2">
        <label class="vs-input--label">Assigned Application</label>
        <v-select v-model="application_local"
                  :clearable="false"
                  :options="applicationsOptions"
                  v-validate="'required'"
                  name="Application_PK"/>
        <span class="text-danger text-sm"
              v-show="vErrors.has('Application_PK')">{{ vErrors.first('Application_PK') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.value)),
      applicationId: null,
      applications: [],
    }
  },
  computed: {
    application_local: {
      get () {
        const applicationId = this.applicationId;
        const app = this.applications.find(({ id }) => id === applicationId);

        if (!app) {
          return app;
        }

        return { label: app.ApplicationName,  value: app.id  }
      },
      set (obj) {
        this.data_local.applicationId = obj.value
        this.applicationId = obj.value;
      }
    },
    validateForm () {
      return !this.vErrors.any()
    },
    applicationsOptions() {
      return this.applications.map(({ id, ApplicationName }) => { return { label: ApplicationName, value: id }  });
    },
  },
  watch: {
    data_local: {
      handler(newData) {
        this.$emit('input', newData);
      },
      deep: true,
    },
  },
  created() {
    this.getRelatedData();
  },
  methods: {
    async getRelatedData() {
      await this.getApplications();
    },
    async getApplications() {
      try {
        const { data } = await this.$api.applications.list();
        this.applications = data.data;
      } catch (e) {
        this.$vs.notify({
          title: 'Error occurred',
          text: 'Not able to retrieve list of applications. Please try again.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      }
    },
  }
}
</script>
